import React from 'react';
import styled from 'styled-components';
import { FiX } from 'react-icons/fi';

import { Text } from 'UI';

type Props = {
  children: JSX.Element | JSX.Element[];
  isOpen: boolean;
  onClose: () => void;
  width?: string;
  height?: string;
  title?: string;
};

export const Modal = ({
  children,
  isOpen,
  onClose,
  width,
  height,
  title,
}: Props): JSX.Element => {
  return (
    <ModalOutlet $isOpen={isOpen}>
      <Wrapper $isOpen={isOpen} width={width} height={height}>
        <ModalHeader>
          {title && <Text label={title} weight={600} level={2} margin="0" />}
          <StyledIcon onClick={onClose}>
            <FiX />
          </StyledIcon>
        </ModalHeader>
        {children}
      </Wrapper>
    </ModalOutlet>
  );
};

const ModalOutlet = styled.div<{ $isOpen: boolean }>`
  visibility: ${({ $isOpen }) => ($isOpen ? 'visible' : 'hidden')};
  opacity: ${({ $isOpen }) => ($isOpen ? '1' : '0')};
  height: 100vh;
  width: 100vw;
  align-items: center;
  justify-content: center;
  position: fixed;
  z-index: 100;
  top: 0;
  left: 0;
  text-align: left;
  background-color: rgba(0, 0, 0, 0.4);
  transition: opacity 0.3s ease-in-out, visibility 0.3s ease-in-out;
`;

const Wrapper = styled.div<{
  $isOpen: boolean;
  width?: string;
  height?: string;
}>`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  z-index: 101;
  position: absolute;
  top: ${({ $isOpen }) => ($isOpen ? '50%' : '-200%')};
  left: 50%;
  transform: ${({ $isOpen }) =>
    `translate(-50%, -50%) ${$isOpen ? 'scale(1)' : 'scale(0.5)'}`};
  transition: ${({ $isOpen }) =>
    $isOpen
      ? 'transform 0.3s cubic-bezier(0.18, 0.89, 0.43, 1.19)'
      : 'top 1s ease-in-out, transform 1s ease-in-out'};
  ${({ width }) => width && `width: ${width}`}px;
  ${({ height }) => height && `height: ${height}`}px;
  background-color: #f1f1f1;
  border-radius: 0.5rem;
  padding: 20px;
  z-index: 5;
  border: 3px solid #154077;

  @media (max-width: 640px) {
    width: 95vw;
    max-height: 95vh;
  }
`;

const ModalHeader = styled.div`
  display: flex;
  min-height: 30px;
  width: 100%;
  justify-content: center;
  align-items: center;
  position: relative;
`;

const StyledIcon = styled.span`
  display: flex;
  color: #154077;
  font-size: 30px;
  border-radius: 7px;
  cursor: pointer;
  position: absolute;
  right: 0;
  &:hover {
    outline: 3px solid rgba(170, 187, 0, 0.3);
  }
  transition: transform 0.05s ease-in-out;
  & > svg {
    stroke-width: 3px;
  }
`;
